<style lang="scss">
    .offer-modal {
        overflow: scroll !important;
        .offeror-details {
            margin-bottom: 15px;
            *:not(a) {
                font-size: 14px;
            }
        }
        .sign-out-link {
            color: #0275d8;
        }
        .login-button {
            margin-bottom: 20px;
        }

        .actions{
			border-bottom: 1px solid rgba(200, 200, 200, 0.4) !important;
			padding-top: 15px;
			padding-bottom: 15px;
		}

		.row-buttons{
            margin-left: -15px;
            margin-right: -15px;
			margin-top: 20px;
            .btn {
                padding: 15px 40px !important;
            }
        }

		.btn-close{
			background : #FF1466;
			border-color: #FF1466;
            color: #fff;
		}

		.image-media-content{
            width: 100%;
            border-radius: 5px;
        }

		.details{
			margin-left : 10px;
		}
        .user-section{
            margin-bottom: 10px;
        }

        .form-control{
            border-radius: 5px !important;
            font-family: Poppins !important;
            font-size: 12px !important;
            font-weight: 500 !important;
        }

        .icon-input{
            border-radius: 0px 5px 5px 0px !important;
        }

        .md-check > i:before{
            width: 16px !important;
            height: 16px !important;
            border-radius: 3px !important;
            border: 1px solid #a7a7a7 !important;
        }

        .md-check > i:after{
            left: 6px !important;
            top: 1px !important;
            width: 5px !important;
            height: 12px !important;
        }

        .control-label{
            color:#595E63;
            font-size:14px;
        }

        .url-link{
			font-family: Poppins;
			font-size: 14px;
			font-weight: 500;
		}

        .terms-link{
            margin-bottom: 20px;
            color : #595E63;
            font-size : 12px;
        }
    }

	@media screen and (max-width: 768px) {
        .offer-modal{


        }
    }
    
    @media screen and (max-width: 543px) {
        .offer-modal{
            .details{
                margin-left: unset;
            }
            .user-section{
                margin-top: 20px;
            }
            .row-buttons{
                margin-left: 0;
                margin-right: 0;
            }
            .btn-success{
                width: 100%;
                margin-top: 20px;
            }
            .btn-buy{
                width: 100%;
            }
        }
    }
    
</style>

<template>
    <div class="offer-modal modal fade" id="offerModal" ref="offer-modal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12" v-if="offerable">
                                    <h4 class="modal-title" :style="$highlightColor">Make an offer for {{ offerable.beat.name }}</h4>
                                    <p>To make an offer for a <strong>{{ offerable.price.name }}</strong> version of <strong>{{ offerable.beat.name }}</strong> please enter your name, email address and the amount and the offer will be sent to
                                    <strong>{{ user.name }}</strong>. The offer will be valid for 48 hours.</p>

                                    <div class="row actions">
										<div class="col-xs-12 col-sm-5 col-md-4">
											<img class="image-media-content" :src="offerable.beat.image(300)">
										</div>
										<div class="col-xs-12 col-sm-7 col-md-8">
											<div class="row details">
												
                                                <div v-if="loggedInUser" class="user-section col-xs-12 col-sm-12 col-md-12">
                                                    <div>Make an offer as <strong>{{loggedInUser.name}}</strong></div>
                                                    <span>Not you? <a href="javascript:;" @click="logout()" class="url-link" :style="$highlightColor">Sign Out</a></span>
                                                </div>

                                                <template v-else>
                                                    <div class="user-section text-center col-xs-12 col-sm-12 col-md-12">
                                                        Already have an account? <a data-toggle="modal" href="#loginModal" class="text-center url-link" :style="$highlightColor">Login Now</a>
                                                    </div>

                                                    <div class="form-group col-xs-12 col-sm-12 col-md-12" :class="{'has-error': errors.has('name')}">
                                                        <label>Name</label>
                                                        <input class="form-control" type="text" v-model="name" placeholder="Name">
                                                        <span class="help-block" v-if="errors.has('name')">
                                                            <span v-for="error in errors.get('name')">
                                                                {{ error }}<br>
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <div class="form-group col-xs-12 col-sm-12 col-md-12" :class="{'has-error': errors.has('email')}">
                                                        <label>Email</label>
                                                        <input class="form-control" type="email" v-model="email" placeholder="Email">
                                                        <span class="help-block" v-if="errors.has('email')">
                                                            <span v-for="error in errors.get('email')">
                                                                {{ error }}<br>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </template>

                                                <div class="form-group col-xs-12 col-sm-12 col-md-12" :class="{'has-error': errors.has('offer_amount')}">
                                                    <label>Amount</label>
                                                    <div class="input-group">
                                                        <span class="input-group-addon input-icon">$</span>
                                                        <input class="form-control icon-input" type="text" v-model="offer_amount" placeholder="Amount">
                                                    </div>
                                                    <span class="help-block" v-if="errors.has('offer_amount')">
                                                        <span v-for="error in errors.get('offer_amount')">
                                                            {{ error }}<br>
                                                        </span>
                                                    </span>
                                                </div>

                                                <div class="form-group col-xs-12 col-sm-12 col-md-12" :class="{'has-error': errors.has('customerMessage')}">
                                                    <label>Message</label>
                                                    <textarea class="form-control" type="text" v-model="customerMessage" placeholder="Your message..."></textarea>
                                                    <span class="help-block" v-if="errors.has('customerMessage')">
                                                        <span v-for="error in errors.get('customerMessage')">
                                                            {{ error }}<br>
                                                        </span>
                                                    </span>
                                                </div>

                                                <div class="alert alert-danger col-xs-12 col-sm-12 col-md-12" v-if="errors.has('other')">
                                                    <span v-for="error in errors.get('other')">
                                                        {{ error }}<br>
                                                    </span>
                                                </div>
                                                <div class="alert alert-success col-xs-12 col-sm-12 col-md-12" v-if="success">
                                                    {{ message }}
                                                </div>
											</div>
										</div>
									</div>
									<div class="row text-right row-buttons">
										<div class="form-group col-xs-12 col-sm-12 col-md-12">
                                            <button v-if="isSaleable" type="button" :style="$mainButtonStyle" class="btn btn-buy" @click="addToCart(offerable.beat, offerable.price, $event)">
                                                <i class="fa fa-shopping-cart"></i>
                                                Buy Now: {{ beatPrice.price | displayPrice }}
                                            </button>
											<button type="button" class="btn btn-success" @click="offer">
                                                <font-awesome-icon v-if="!offerLoading" :icon="['far', 'envelope']"></font-awesome-icon>
                                                <font-awesome-icon v-else :icon="['far', 'spinner-third']" spin></font-awesome-icon>
                                                Submit Offer
                                            </button>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		
	</div>
   
</template>
<script>
    import CartItem from '../../classes/CartItem'
    import Errors from '../../classes/Errors'
    import Configure from '../../mixins/configure'
    import SecondaryModal from '../../mixins/secondary-modal'

    import Login from '../../mixins/login.vue'

    export default {
        props: ['offerable'],
        mounted() {
            $(this.$el).on("hide.bs.modal", () => {
                this.reset();
            })

            this.$store.commit("offerModal", {modal: $(this.$el)})
        },
        mixins: [Login, Configure, SecondaryModal],
        data() {
            return {
                user: this.$store.state.user,
                name: '',
                email: '',
                offer_amount: '',
                customerMessage: '',
                success: false,
                errors: new Errors(),
                message: '',
                offerLoading: false
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser
            },
            beatPrice() {
                if (this.offerable) {
                    return this.offerable.beat.pricing[this.offerable.price.id]
                }
            },
            isSaleable() {
                if (this.offerable) {
                    return this.beatPrice.isSaleable()
                }
            }
        },
        methods: {
            addToCart(beat, license, event) {
                this.$store.state.cart.addItem(new CartItem(beat, license, this.offerable.price, 'beat'))

                $(this.$refs['offer-modal']).modal('hide');

                event.stopPropagation();
            },
            offer () {
                this.errors.clear();
                this.success = false;
                this.message = '';

                if (this.offer_amount == '') {
                    this.errors.add('offer_amount', 'Amount is required');
                }

                if (!this.loggedInUser && this.name == '') {
                    this.errors.add('name', 'Name is required');
                }

                if (!this.loggedInUser && this.email == '') {
                    this.errors.add('email', 'Email is required');
                }

                var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!this.loggedInUser && !regex.test(this.email)) {
                    this.errors.add('email', 'Email is invalid');
                }

                if (isNaN(parseFloat(this.offer_amount)) || parseFloat(this.offer_amount) <= 0) {
                    this.errors.add('offer_amount', 'Amount must be a monetary value');
                }

                if (this.errors.any()) {
                    return false;
                }

                this.offerLoading = true;

                let data = {
                    loggedIn: !! this.loggedInUser,
                    offer_amount: this.offer_amount,
                    message: this.customerMessage,
                    license_id: this.offerable.price.id
                }

                if (this.loggedInUser) {
                    data.api_token = this.loggedInUser.token
                } else {
                    data.name = this.name
                    data.email = this.email
                }

                this.$http.post(`${ab.apiUrl}/beats/${this.offerable.beat.id}/offers`, data)
                    .then((response) => {
                        this.success = true;
                        this.errors.clear();
                        this.offerLoading = false;

                        if (this.loggedInUser) {
                            this.message = 'Offer Sent';

                            setTimeout(() => {
                                $(this.$refs['offer-modal']).modal('hide');
                            }, 1000);
                        } else {
                            this.message = `An activation email from Airbit has been sent to your email address. Your offer will be sent to ${this.user.name} once you click the link in the email and activate your Airbit account.`
                        }

                    })
                    .catch((error) => {
                        this.success = false;
                        let message = error.response.data.error.message;

                        if (typeof message === 'string') {
                            this.errors.add('other', message);
                        } else {
                            this.errors.addAll(message);
                        }

                        this.offerLoading = false;
                    })
            },
            reset() {
                this.offer_amount = '';
                this.success = false;
                this.errors.clear();
                this.message = '';
                this.customerMessage = '';
                this.offerLoading = false;
            },
        },
    }
</script>
